import { AppliedJobs } from './applied-jobs';
import { AppliedJobsProvider } from './applied-jobs.provider';

export const JSAppliedJobs = () => (
   <AppliedJobsProvider>
      <AppliedJobs />
   </AppliedJobsProvider>
);
